import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import '../styles/faq.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});
  const [activeCategory, setActiveCategory] = useState('pristup');

  // Handle accordion toggle - only one item open at a time
  const toggleAccordion = (itemId) => {
    setOpenItems(prev => {
      // If the clicked item is already open, close it
      if (prev[itemId]) {
        return { [itemId]: false };
      }
      // Otherwise, close all items and open only the clicked one
      return { [itemId]: true };
    });
  };



  // Scrollspy for FAQ navigation
  useEffect(() => {
    const handleScroll = () => {
      const faqCategories = document.querySelectorAll('.faq-category');
      let current = 'pristup';

      faqCategories.forEach(category => {
        const categoryTop = category.offsetTop;
        if (window.pageYOffset >= categoryTop - 150) {
          current = category.getAttribute('id');
        }
      });

      setActiveCategory(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>FAQ Instrukcije | Često Postavljana Pitanja - Konto Zona</title>
        <meta name="description" content="Najčešća pitanja o instrukcijama iz računovodstva, ekonomije, statistike i matematike. Informacije o cijenama, terminima, online radu, skriptama i rezervacijama." />
        <meta name="keywords" content="FAQ instrukcije, pitanja o instrukcijama, kako funkcioniraju instrukcije, cijene instrukcija, online instrukcije kako funkcioniraju, instrukcije računovodstvo pitanja, instrukcije ekonomija pitanja" />
        <meta property="og:title" content="FAQ Instrukcije | Često Postavljana Pitanja - Konto Zona" />
        <meta property="og:description" content="Odgovori na sva vaša pitanja o instrukcijama računovodstvo, instrukcijama ekonomija, skriptama, cijenama i načinu rada." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://instrukcijekontozona.hr/faq" />
        <meta property="og:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <meta property="og:locale" content="hr_HR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="FAQ Instrukcije | Često Postavljana Pitanja - Konto Zona" />
        <meta name="twitter:description" content="Odgovori na sva vaša pitanja o instrukcijama računovodstvo, instrukcijama ekonomija, skriptama, cijenama i načinu rada." />
        <meta name="twitter:image" content="https://instrukcijekontozona.hr/kontozona-logo.png" />
        <link rel="canonical" href="https://instrukcijekontozona.hr/faq" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Kako funkcioniraju instrukcije?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Instrukcije se odvijaju online ili uživo, individualno ili u grupama. Rezervirate termin, dobijete pristup materijalima i nakon svakog sata dobijete sažetak u PDF-u."
                }
              },
              {
                "@type": "Question",
                "name": "Koliko koštaju instrukcije?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Individualne instrukcije koštaju 18€ po satu, a grupne instrukcije 12€ po satu po osobi."
                }
              },
              {
                "@type": "Question",
                "name": "Koje predmete pokrivate?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Nudimo instrukcije iz računovodstva, ekonomije, statistike i matematike za studente i srednjoškolce."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* SEKCIJA 1: HERO ZA FAQ */}
      <section className="section hero-final" style={{
        padding: '40px 0',
        minHeight: 'auto',
        height: 'auto',
        display: 'block',
        alignItems: 'unset'
      }}>
        <div className="container text-center">
          <h1 className="main-headline" style={{ color: "var(--text-primary)" }}>Imate pitanje? Imamo odgovor.</h1>
          <p className="hero-subtitle">
            Sve što vas zanima o našem pristupu, uslugama i načinu rada na
            jednom mjestu.
          </p>
        </div>
      </section>

      {/* SEKCIJA 2: FAQ - "PRO MAX" DIZAJN S LIJEVOM NAVIGACIJOM */}
      <section className="section faq-section-v2">
        {/* LIJEVA NAVIGACIJA - PREČICE - IZVAN GRIDA */}
        <aside className="faq-nav-desktop">
          <h4>Kategorije</h4>
          <ul>
            <li>
              <a
                href="#pristup"
                className={`faq-nav-link ${activeCategory === 'pristup' ? 'active' : ''}`}
                data-target="pristup"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveCategory('pristup');
                  document.getElementById('pristup').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="fas fa-brain"></i> O našem pristupu
              </a>
            </li>
            <li>
              <a
                href="#logistika"
                className={`faq-nav-link ${activeCategory === 'logistika' ? 'active' : ''}`}
                data-target="logistika"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveCategory('logistika');
                  document.getElementById('logistika').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="fas fa-cogs"></i>Sve što trebaš znati
              </a>
            </li>
            <li>
              <a
                href="#vrijednost"
                className={`faq-nav-link ${activeCategory === 'vrijednost' ? 'active' : ''}`}
                data-target="vrijednost"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveCategory('vrijednost');
                  document.getElementById('vrijednost').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="fas fa-gem"></i> Vrijednost i Materijali
              </a>
            </li>
            <li>
              <a 
                href="#ostalo" 
                className={`faq-nav-link ${activeCategory === 'ostalo' ? 'active' : ''}`}
                data-target="ostalo"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveCategory('ostalo');
                  document.getElementById('ostalo').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="fas fa-users"></i> Grupne instrukcije i Skripte
              </a>
            </li>
          </ul>
        </aside>

        <div className="container">
          {/* MOBILNA NAVIGACIJA */}
          <aside className="faq-nav-mobile">
            <h4>Kategorije</h4>
            <ul>
              <li>
                <a
                  href="#pristup"
                  className={`faq-nav-link ${activeCategory === 'pristup' ? 'active' : ''}`}
                  data-target="pristup"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveCategory('pristup');
                    document.getElementById('pristup').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="fas fa-brain"></i> O našem pristupu
                </a>
              </li>
              <li>
                <a
                  href="#logistika"
                  className={`faq-nav-link ${activeCategory === 'logistika' ? 'active' : ''}`}
                  data-target="logistika"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveCategory('logistika');
                    document.getElementById('logistika').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="fas fa-cogs"></i>Sve što trebaš znati
                </a>
              </li>
              <li>
                <a
                  href="#vrijednost"
                  className={`faq-nav-link ${activeCategory === 'vrijednost' ? 'active' : ''}`}
                  data-target="vrijednost"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveCategory('vrijednost');
                    document.getElementById('vrijednost').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="fas fa-gem"></i> Vrijednost i Materijali
                </a>
              </li>
              <li>
                <a 
                  href="#ostalo" 
                  className={`faq-nav-link ${activeCategory === 'ostalo' ? 'active' : ''}`}
                  data-target="ostalo"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveCategory('ostalo');
                    document.getElementById('ostalo').scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <i className="fas fa-users"></i> Grupne instrukcije i Skripte
                </a>
              </li>
            </ul>
          </aside>

          {/* DESNI SADRŽAJ - PITANJA */}
          <div className="faq-content-v2">
            {/* Kategorija 1 */}
            <div id="pristup" className="faq-category">
              <h2><i className="fas fa-brain"></i> O našem pristupu</h2>
              <div className="accordion">
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['pristup-1'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('pristup-1')}
                  >
                    Po čemu se naš pristup razlikuje od klasičnih instrukcija?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['pristup-1'] ? 'active' : ''}`}
                  >
                    <p>
                      Mi ne učimo napamet. Naš fokus je na
                      <strong> dubinskom razumijevanju</strong>. Nećemo vam samo
                      pokazati <em>kako</em> riješiti zadatak, već i
                      <em>zašto</em> se rješava upravo na taj način. Kada
                      shvatite logiku, svaki budući problem postaje lakši.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['pristup-2'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('pristup-2')}
                  >
                    Je li ovaj pristup za mene ako krećem od nule?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['pristup-2'] ? 'active' : ''}`}
                  >
                    <p>
                      Naravno. Naša metodologija je{' '}
                      <strong>krojena po tebi</strong>. Bilo da se prvi put
                      susrećeš s gradivom ili samo brusiš finese za najvišu
                      ocjenu, mi se prilagođavamo tvom znanju i tvom tempu. Naš
                      jedini plan je tvoj uspjeh.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['pristup-3'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('pristup-3')}
                  >
                    Zašto odabrati nas, a ne nekog starijeg profesora?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['pristup-3'] ? 'active' : ''}`}
                  >
                    <p>
                      Zato što sam i sam nedavno bio "u vašim cipelama". Točno
                      znam gdje gradivo "zapinje" i što profesori traže. Moj
                      pristup je{' '}
                      <strong>moderan, relevantan i bez suvišne teorije</strong>
                      – fokusiran isključivo na ono što vam treba za uspjeh.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['pristup-4'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('pristup-4')}
                  >
                    Što ako zapnem na konkretnom zadatku?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['pristup-4'] ? 'active' : ''}`}
                  >
                    <p>
                      To je naš teren. Zaboravi na kruti plan. Ako te muči
                      zadatak s kolokvija, vježbi ili starog ispita, <br />
                      <strong>
                         to u tom trenutku postaje naš jedini prioritet
                      </strong>
                      . Mi ne predajemo gradivo, mi rješavamo tvoj problem.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Kategorija 2 */}
            <div id="logistika" className="faq-category">
              <h2><i className="fas fa-cogs"></i> Sve što trebaš znati</h2>
              <div className="accordion">
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['logistika-1'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('logistika-1')}
                  >
                    Kako mogu najbrže zakazati termin?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['logistika-1'] ? 'active' : ''}`}
                  >
                    <p>
                      <strong>Pošalji nam poruku na WhatsApp</strong> – to je
                      najbrži i najjednostavniji način za dogovor. Također,
                      možeš ispuniti našu kontakt formu ili nas kontaktirati
                      putem poziva. Javit ćemo se u najkraćem roku s potvrdom.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['logistika-2'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('logistika-2')}
                  >
                    Kako i kada se vrši plaćanje?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['logistika-2'] ? 'active' : ''}`}
                  >
                    <p>
                      Plaćanje se vrši <strong>unaprijed</strong> kako bi vaša
                      rezervacija termina bila potvrđena. Nakon što uskladimo
                      termin, poslat ćemo vam sve potrebne podatke za
                      jednostavno i sigurno bankovno plaćanje.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['logistika-3'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('logistika-3')}
                  >
                    Kakva su pravila za otkazivanje termina?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['logistika-3'] ? 'active' : ''}`}
                  >
                    <p>
                      Cijenimo tvoje i naše vrijeme. Zato te molimo da
                      eventualno otkazivanje ili pomicanje termina                       javiš{' '}
                      <strong>najmanje 48 sati unaprijed</strong>. Za
                      otkazivanja unutar 48 sati, termin se nažalost smatra
                      iskorištenim. Hvala na razumijevanju!
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['logistika-4'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('logistika-4')}
                  >
                    Što mi je potrebno od opreme?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['logistika-4'] ? 'active' : ''}`}
                  >
                    <p>
                      Sve što već imaš:{' '}
                      <strong>stabilna internet veza i uređaj po izboru</strong>
                      (mobitel, tablet ili računalo). Instrukcije se održavaju
                      preko Microsoft Teamsa, kojem možeš pristupiti direktno
                      putem preglednika bez ikakve instalacije.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Kategorija 3 */}
            <div id="vrijednost" className="faq-category">
              <h2><i className="fas fa-gem"></i> Vrijednost i Materijali</h2>
              <div className="accordion">
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['vrijednost-1'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('vrijednost-1')}
                  >
                    Dobivam li zaista punu vrijednost za svoj novac?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['vrijednost-1'] ? 'active' : ''}`}
                  >
                    <p>
                      Apsolutno. Svaki naš sat traje{' '}
                      <strong>punih 60 minuta</strong> čistog, fokusiranog rada.
                      Nema praznog hoda, nema izgubljenog vremena – samo
                      maksimalna efikasnost usmjerena na tvoj cilj.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['vrijednost-2'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('vrijednost-2')}
                  >
                    Dobivam li kakve materijale nakon sata?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['vrijednost-2'] ? 'active' : ''}`}
                  >
                    <p>
                      Nakon svakog sata, dobivaš{' '}
                      <strong>personalizirani PDF zapisnik</strong> na e-mail.
                      To je tvoja digitalna bilježnica sa svim zadacima i
                      bilješkama sa sata, kojoj se uvijek možeš vratiti.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Kategorija 4 */}
            <div id="ostalo" className="faq-category">
              <h2><i className="fas fa-users"></i> Grupne instrukcije i Skripte</h2>
              <div className="accordion">
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['ostalo-1'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('ostalo-1')}
                  >
                    Mogu li se priključiti postojećoj grupi?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['ostalo-1'] ? 'active' : ''}`}
                  >
                    <p>
                      Trenutno <strong>ne spajamo pojedince u grupe</strong>.
                      Naša filozofija je da grupe najbolje funkcioniraju kada se
                      sastoje od kolega koji se već poznaju i dijele sličan
                      tempo rada.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['ostalo-2'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('ostalo-2')}
                  >
                    Što ako je znanje unutar grupe neujednačeno?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['ostalo-2'] ? 'active' : ''}`}
                  >
                    <p>
                      To je upravo situacija gdje mentor dolazi do izražaja. Naš
                      je zadatak voditi sat na način da{' '}
                      <strong>svatko dobije ono što mu treba</strong> –
                      napredniji studenti dobivaju dodatne izazove, a oni kojima
                      treba više vremena dobivaju dodatna pojašnjenja.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['ostalo-3'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('ostalo-3')}
                  >
                    Po čemu će se vaše skripte razlikovati od ostalih?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['ostalo-3'] ? 'active' : ''}`}
                  >
                    <p>
                      Naše skripte nisu samo sažetak gradiva. One su{' '}
                      <strong>sustav za učenje</strong>. Svaka skripta je pisana
                      s jednim ciljem: pružiti vam{' '}
                      <strong>najkraći i najkvalitetniji put do petice</strong>.
                    </p>
                  </div>
                </div>
                <div className="accordion-item">
                  <button 
                    className={`accordion-header ${openItems['ostalo-4'] ? 'active' : ''}`}
                    onClick={() => toggleAccordion('ostalo-4')}
                  >
                    Kako mogu saznati kada skripte budu dostupne?
                    <i className="fas fa-plus"></i>
                  </button>
                  <div 
                    className={`accordion-content ${openItems['ostalo-4'] ? 'active' : ''}`}
                  >
                    <p>
                      Naše prve skripte su u finalnoj fazi pripreme. Najbolji
                      način da prvi dobijete obavijest je da se{' '}
                      <strong>prijavite na naš newsletter</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
